import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import { store } from "@/store/index.js";
import vuetify from "@/plugins/vuetify";
import i18n from "./i18n";
import { setLocale } from "@/locales/languages.js";
import "intersection-observer";

import "@/style/main.css";

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  setLocale(to.params.locale, i18n);
  next();
});

import VueGtm from "vue-gtm";

Vue.use(VueGtm, {
  id: "GTM-T7BMQVD", // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
